/**Costante che memorizza lo schema di associazione path - icona di menu - profili autorizzati */
export const autorizzazioni = {
    "utenti": {
        icona: {
            label: "person",
            nav: "utenti",
        },
        profili: ['Administrator']
    },
    "supervisione": {
        icona: {
            label: "event",
            nav: "supervisione",
        },
        profili: [
            'Administrator',
            'Supervisor'
        ]
    },
    "statistiche": {
        icona: {
            label: "equalizer",
            nav: "statistiche",
        },
        profili: [
            'Administrator',
            'Supervisor'
        ]
    },
    "allegati": {
        icona: {
            label: "attach_file",
            nav: "allegati",
        },
        profili: [
            'Administrator',
            'Supervisor',
            'Publisher',
            'Revisor',
            'Translator',
            'Viewer'
        ]
    },
    "glossario": {
        icona: {
            label: "local_offer",
            nav: "glossario",
        },
        profili: [
            'Administrator',
            'Supervisor',
            'Publisher',
            'Revisor',
            'Translator',
            'Viewer'
        ]
    },
    "traduzioni": {
        icona: {
            label: "menu_book",
            nav: "traduzioni",
        },
        profili: [
            'Administrator',
            'Supervisor',
            'Publisher',
            'Revisor',
            'Translator',
            'Viewer'
        ]
    },
    "editoria": {
        icona: {
            label: "description",
            nav: "editoria",
        },
        profili: [
            'Administrator',
            'Supervisor',
            'Publisher',
            'Revisor',
            'Translator'
        ]
    },
    "ricerca": {
        icona: {
            label: "manage_search",
            nav: "ricerca",
        },
        profili: [
            'Administrator',
            'Viewer'
        ]
    },
    "risorse": {
        icona: {
            label: "create_new_folder",
            nav: "risorse",
            dropdown: [
              {
                label: "cloud",
                nav: "lexicon",
              },
              {
                label: "list_alt",
                nav: "terminology",
              },
              {
                label: "people",
                nav: "rabbis",
              },
              {
                label: "book",
                nav: "bible",
              },
              {
                label: "library_books",
                nav: "textLibrary",
              }
            ]
        },
        profili: [
            'Administrator',
            'Supervisor',
            'Publisher',
            'Revisor',
            'Translator',
            'Viewer'
        ]
    }
}